import styled from 'styled-components';
import React, { useCallback, useState } from 'react';
import GoogleMapReact, { Props as MapProps } from 'google-map-react';
import { FlexCol } from 'components/primitives/flex';
import { useAtomValue } from 'jotai';
import { mediaMSmMax } from 'helpers/breakpoints';
import PlusIcon from './images/plus-zoom.svg';
import MinusIcon from './images/minus-zoom.svg';
import { searchMapAsMoveAtom, zoomLevelAtom } from '../Filter/filterStore';
import SearchAsMoveToggle from './SearchAsMoveToggle';
import bootstrapURLKeys from '../../../../../bootstrapURLKeys';

export interface GoogleMapReactProps extends Omit<MapProps, 'children'> {
  children?: React.ReactNode;
}

export default function GoogleMap(props: GoogleMapReactProps & { onDragEndAction: any; map: any }) {
  const { children, onDragEndAction, map, ...rest } = props;
  const zoom = useAtomValue(zoomLevelAtom);
  const [userScrolledToZoom, setUserScrolledToZoom] = useState(false);
  const searchAsMove = useAtomValue(searchMapAsMoveAtom);

  const handleZoomControlsClick = useCallback(
    (zoomAmount: number) => {
      if (!map) {
        return;
      }
      map.setZoom(map.getZoom() + zoomAmount);
      if (searchAsMove) {
        onDragEndAction(true, zoom + zoomAmount);
      }
    },
    [searchAsMove, onDragEndAction, map, zoom]
  );

  return (
    <Wrapper
      onWheel={() => {
        setUserScrolledToZoom(true);
      }}
    >
      <SearchAsMoveToggle onDragEndAction={onDragEndAction} />
      <GoogleMapReact
        onDragEnd={() => onDragEndAction(false)}
        onZoomAnimationEnd={() => {
          if (userScrolledToZoom) {
            onDragEndAction(true);
            setUserScrolledToZoom(false);
          }
        }}
        bootstrapURLKeys={bootstrapURLKeys}
        {...(typeof window !== 'undefined' &&
          window.google?.maps && {
            googleMapLoader: () => Promise.resolve(window.google.maps),
          })}
        {...rest}
      >
        {children}
      </GoogleMapReact>
      <ZoomWrapper>
        <Control onClick={() => handleZoomControlsClick(1)}>
          <PlusIcon />
        </Control>
        <Control onClick={() => handleZoomControlsClick(-1)}>
          <MinusIcon />
        </Control>
      </ZoomWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  height: 100%;
  ${mediaMSmMax} {
    overscroll-behavior: contain;
  }
`;

const ZoomWrapper = styled(FlexCol)`
  position: absolute;
  bottom: 25px;
  right: 15px;
  gap: 5px;
`;

const Control = styled.div`
  cursor: pointer;
`;
